export function etapaLead(value: number): string {
  switch (value) {
    default:
      return "";
    case 0:
      return "Oportunidade";
    case 1:
      return "Primeiro Contato";
    case 2:
      return "Segundo Contato";
  }
}

export function statusLead(value: number): string {
  switch (value) {
    default:
      return "";
    case 1:
      return "Em Processo";
    case 2:
      return "Qualificado";
    case 3:
      return "Ganho";
    case 4:
      return "Perda";
    case 8:
      return "Já cadastrado";
    case 9:
      return "Erro";
  }
}

export function motivoLead(value: number): string {
  switch (value) {
    default:
      return "";
    case 1:
      return "Sem retorno";
    case 2:
      return "Não tem interesse";
    case 3:
      return "E.O. não atende";
    case 4:
      return "Parou de vender";
    case 5:
      return "Achou caro";
    case 6:
      return "Número não existe";
    case 99:
      return "Inatividade atendimento";
  }
}

export function tipoLead(value: number): string {
  switch (value) {
    case 1:
      return "Indicação";
    case 2:
      return "Campanha";
    case 3:
      return "Prospecção";
    default:
      return "";
  }
}
